import React from "react";
import Category from "./Category/Category";

export default function CategorySetting() {
  return <Category />;
}
